// http-cache.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable, of, BehaviorSubject } from 'rxjs';

interface CacheEntry {
  data: any;
  expiry: number;
  loading$: BehaviorSubject<boolean>;
}

@Injectable({
  providedIn: 'root'
})
export class HttpCacheService {
  private cache: Map<string, CacheEntry> = new Map();
  private defaultDuration = 5 * 60 * 1000; // 5 minutos por defecto

  constructor(private http: HttpClient) { }

  /**
   * Obtiene datos de la API con caché
   */

  // http-cache.service.ts - Añade este método
  getResponse<T>(url: string, options?: any, cacheDuration?: number, cacheKey?: string): Observable<HttpEvent<T>> {
    const key = cacheKey || url;
    const entry = this.cache.get(key);
    const now = Date.now();

    if (entry && entry.expiry > now) {
      // Devolver la respuesta cacheada como HttpResponse
      return of(new HttpResponse<T>({
        body: entry.data,
        status: 200,
        url: url
      })) as Observable<HttpEvent<T>>;
    }

    // Si no hay en caché, retorna null (el interceptor seguirá con la petición)
    return of(null as any);
  }
  /**
   * Guarda directamente una respuesta en la caché
   */
  set<T>(url: string, data: T, cacheDuration?: number, cacheKey?: string): void {
    const key = cacheKey || url;
    const duration = cacheDuration || this.defaultDuration;
    const now = Date.now();

    this.cache.set(key, {
      data,
      expiry: now + duration,
      loading$: new BehaviorSubject<boolean>(false)
    });
  }

  /**
   * Limpia toda la caché o una entrada específica
   */
  clearCache(cacheKey?: string): void {
    if (cacheKey) {
      this.cache.delete(cacheKey);
    } else {
      this.cache.clear();
    }
  }
}
